import { render } from "./Team.vue?vue&type=template&id=fac96d46&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=fac96d46&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fac96d46"]])

export default __exports__